import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/CutleryFilled.tsx
import React from "react";
var SvgCutleryFilled, CutleryFilled_default;
var init_CutleryFilled = __esm({
  "src/icons/CutleryFilled.tsx"() {
    SvgCutleryFilled = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "m4.222 3.808 6.717 6.717-2.828 2.829-3.89-3.89a4 4 0 0 1 0-5.656h.001Zm10.046 8.338-.854.854 7.071 7.071-1.414 1.414L12 14.415l-7.071 7.07-1.414-1.414 9.339-9.339c-.588-1.457.02-3.555 1.62-5.157 1.953-1.952 4.644-2.427 6.011-1.06s.892 4.058-1.06 6.01c-1.602 1.602-3.7 2.21-5.157 1.621Z"
        }
      )
    );
    CutleryFilled_default = SvgCutleryFilled;
  }
});

export {
  CutleryFilled_default,
  init_CutleryFilled
};
